import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-bg">
    <span className="text-[11px] uppercase tracking-ultra text-ink-soft animate-pulse">Loading…</span>
  </div>
);

export function ProtectedRoute({ children, admin = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/account" replace />;
  return children;
}
